import { RolesResponse } from "../api-user/roles/roles.response.model";



export class UsersRequest{
    email: string;
    enabled: boolean;
    name: string;
    note: string;
    role: RolesResponse[];
    surname: string;
    
}

export class UsersRequestList{
    name: string;
    pageNumber: number;
    pageSize:number;
    sortBy: string;
    
}

export class UsersAddRoles{
    listaPermissions: number[]; 
    
}

export class UsersRemoveRoles{
    listaPermissions: number[]; 
    
}

export class UsersRequestStore{
    listaStores: number[]; 
    
}


export class UsersRequestSearch{
    pageNumber: number;
    pageSize: number;
    query: string;
    role: number;
    sortBy: string;
    
}